// import React, { Component } from 'react'
// import Cookies from 'universal-cookie'
// import '../CSS/assets-minified/all-demo.css'
// import '../CSS/assets-minified/css/bootstrap.min.css'
// import Header from '../components/dashboardSubComponents/header'
// import SideBar from '../components/dashboardSubComponents/sideBarNav'
// import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
// import Fade from 'react-reveal/Fade'
// import { Loader } from 'react-overlay-loader'
// import OrganizationViewPanel from '../components/OrganizationViewSubComponents/organizationViewPanel'
// import { url, media_url, logout } from '../components/helper'
// // import update from 'react-addons-update';
// import BottomScrollListener from 'react-bottom-scroll-listener'
// import loadingGif from '../CSS/assets-minified/images/loadingMore.gif'

// class OrganizationList extends Component {
//     constructor(props) {
//         super(props)
//         this.state = {
//             super_admin: '',
//             org_admin: '',
//             org_list: [
//                 { organisation_name: 'Metrol' },
//                 { organisation_name: 'Duke' },
//                 { organisation_name: 'HHM' },
//             ],
//             section: 0,
//             editModalOpen: false,
//             editTarget: { org_name: 'fake', org_logo: 'logo' },
//             editImageChanged: false,
//             deleteModalOpen: false,
//             deleteTarget: { org_id: 'id' },
//             editCurrentImg:
//                 'https://res.cloudinary.com/argon-tech/image/upload/v1532955025/kncikwliledqmw1nlqih.jpg',
//             loading: false,
//             message_title: '',
//             message_body: '',
//             message_type: 1,
//             message_box_open: false,
//             FileErrorHidden: true,
//             inactive_count: 0,
//             org_days: 1,
//             contentLoaderHidden: true,
//             currentPage: 1,
//             hasNext: false,
//         }
//         navigateCreateOrganization = navigateCreateOrganization.bind(this)
//         this.search_target_organization =
//             this.search_target_organization.bind(this)
//         openFileBrowser = openFileBrowser.bind(this)
//         changePreviewImg = changePreviewImg.bind(this)
//         this.hasExtension = this.hasExtension.bind(this)
//         updateOrganization = updateOrganization.bind(this)
//         closeMessageBoxModal = closeMessageBoxModal.bind(this)
//         closeEditModal = closeEditModal.bind(this)
//         this.triggerOrgDeletion = this.triggerOrgDeletion.bind(this)
//         closeDeleteModal = closeDeleteModal.bind(this)
//         deleteOrganization = deleteOrganization.bind(this)
//         handleNameInputChange = handleNameInputChange.bind(this)
//         this.handleDaysInputChange = this.handleDaysInputChange.bind(this)
//         loadMore = loadMore.bind(this)
//     }

//     componentWillMount = () => {
//         const cookies = new Cookies()
//         var loginStatus = cookies.get('loggedIn')
//         var branch_admin = cookies.get('branch-admin')
//         var superuser = cookies.get('superuser')
//         var organization_admin = cookies.get('organization-admin')

//         //(loginStatus)
//         if (loginStatus === undefined) {
//             window.location = '/login'
//         }
//         if (branch_admin === 'true') {
//             window.location = '/dashboard'
//         }
//         this.setState({
//             super_admin: superuser,
//             org_admin: organization_admin,
//         })
//         var http = new XMLHttpRequest()
//         var dashboar_ref = this
//         var user_id = cookies.get('user_id')
//         var token = cookies.get('token')
//         //(url+'/api/organisation?user_id='+user_id)
//         http.open(
//             'GET',
//             url +
//                 '/api/organisation?user_id=' +
//                 user_id +
//                 '&page=' +
//                 this.state.currentPage,
//             true
//         )
//         http.setRequestHeader('Authorization', 'Token ' + token)

//         http.onreadystatechange = function () {
//             if (http.readyState === 4 && http.status === 200) {
//                 var json = JSON.parse(http.responseText)
//                 //(http.responseText)
//                 if (json.status === 200) {
//                     console.log(json.organisations)
//                     dashboar_ref.setState({
//                         org_list: json.organisations,
//                         inactive_count: json.inactive_orgs_count,
//                         hasNext: json.has_next,
//                         section: 1,
//                     })
//                 } else {
//                     dashboar_ref.setState({
//                         inactive_count: json.inactive_orgs_count,
//                         section: 2,
//                     })
//                 }
//             }
//             if (http.readyState === 4 && http.status === 401) {
//                 logout()
//             }
//         }

//         http.send()
//     }

//     loadMore = () => {
//         if (this.state.hasNext === true) {
//             // alert("fetchng")
//             this.setState({
//                 currentPage: this.state.currentPage + 1,
//                 contentLoaderHidden: false,
//             })
//             const cookies = new Cookies()
//             var http = new XMLHttpRequest()
//             var dashboar_ref = this
//             var user_id = cookies.get('user_id')
//             var token = cookies.get('token')
//             //(url+'/api/organisation?user_id='+user_id)
//             http.open(
//                 'GET',
//                 url +
//                     '/api/organisation?user_id=' +
//                     user_id +
//                     '&page=' +
//                     this.state.currentPage,
//                 true
//             )
//             http.setRequestHeader('Authorization', 'Token ' + token)

//             http.onreadystatechange = function () {
//                 if (http.readyState === 4 && http.status === 200) {
//                     var json = JSON.parse(http.responseText)
//                     //(http.responseText)
//                     if (json.status === 200) {
//                         console.log(json.organisations)
//                         dashboar_ref.setState({
//                             // "org_list":json.organisations,
//                             inactive_count: json.inactive_orgs_count,
//                             contentLoaderHidden: true,
//                             hasNext: json.has_next,
//                         })
//                         json.organisations.forEach((element) => {
//                             dashboar_ref.setState((prevState) => ({
//                                 org_list: [...prevState.org_list, element],
//                             }))
//                         })
//                     }
//                 }
//                 if (http.readyState === 4 && http.status === 401) {
//                     logout()
//                 }
//             }

//             http.send()
//         }
//     }

//     handleNameInputChange = () => {
//         var input = document.getElementById('org_name').value
//         //(input)
//         this.setState({
//             org_name: input,
//         })
//     }

//     handleDaysInputChange = () => {
//         var input = document.getElementById('org_days').value
//         this.setState({
//             org_days: input,
//         })
//     }

//     create_organization = () => {
//         window.location = '/create-organization'
//     }

//     close_edit_modal = () => {
//         this.setState({ editModalOpen: false })
//     }
//     close_delete_modal = () => {
//         this.setState({ deleteModalOpen: false })
//     }
//     close_message_box_modal = () => {
//         if (this.state.message_type === 1) {
//             this.setState({
//                 message_box_open: false,
//             })
//             window.location = '/view-organization'
//         }
//         if (this.state.message_type === 2) {
//             this.setState({
//                 message_box_open: false,
//             })
//         }
//     }

//     update_organization = (event) => {
//         event.preventDefault()
//         // var form = document.getElementById('orgData');
//         // // //(form)
//         // var formData = new FormData(form);
//         // //(formData)
//         this.setState({
//             loading: true,
//             editModalOpen: false,
//         })
//         var cookies = new Cookies()
//         var user_id = cookies.get('user_id')
//         var token = cookies.get('token')
//         var global_ref = this
//         var fileInput = null
//         var file = null
//         if (this.state.editImageChanged === true) {
//             fileInput = document.getElementById('logo')
//             var file = fileInput.files[0]
//         }
//         var nameInput = document.getElementById('org_name').value
//         var formData = new FormData()
//         formData.append('org_logo', file)
//         formData.append('org_name', nameInput)
//         formData.append('days', this.state.org_days)
//         formData.append('user_id', user_id)
//         //("@@@@")
//         //(editTarget.organisation_id)
//         formData.append('org_id', editTarget.organisation_id)
//         var http = new XMLHttpRequest()
//         http.open('PUT', url + '/api/organisation', true)
//         http.setRequestHeader('Authorization', 'Token ' + token)
//         //(nameInput)
//         //(fileInput)
//         //(file)
//         http.send(formData)

//         http.onreadystatechange = function () {
//             if (http.readyState === 4 && http.status === 200) {
//                 var json = JSON.parse(http.responseText)
//                 //(json)
//                 //('^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^')
//                 if (json.status === 200) {
//                     var id = '' + global_ref.state.editTarget.organisation_id
//                     //("name"+id)
//                     document.getElementById('name' + id).innerHTML =
//                         json.organisation_name
//                     // global_ref.setState({editTarget:json.organisation_name})

//                     var count = 0
//                     global_ref.state.org_list.forEach((element) => {
//                         if (
//                             element.organisation_id ===
//                             global_ref.state.editTarget.organisation_id
//                         ) {
//                             //("--------")
//                             //("found the bitch")
//                             //(global_ref.state.org_list[count])
//                             // global_ref.setState({
//                             //     ...global_ref.state.org_list[count],
//                             //     organization_name:"test"
//                             // })
//                             global_ref.state.org_list[count].organisation_name =
//                                 json.organisation_name
//                             global_ref.state.org_list[count].organisation_logo =
//                                 json.organisation_logo
//                             global_ref.state.org_list[
//                                 count
//                             ].days_to_delete_photos = json.days_to_delete_photos
//                             global_ref.forceUpdate()
//                         }
//                         //(count)
//                         count++
//                     })

//                     document
//                         .getElementById('logo' + id)
//                         .setAttribute('src', media_url + json.organisation_logo)
//                     global_ref.setState({ loading: false })
//                 } else {
//                     global_ref.setState({
//                         loading: false,
//                         message_title: 'Error',
//                         message_body: 'Organization could not be updated',
//                         message_type: 2,
//                         message_box_open: true,
//                     })
//                 }
//             }
//         }
//         http.ontimeout = function () {
//             global_ref.setState({
//                 loading: false,
//                 message_title: 'Timeout',
//                 message_body: 'Request has timed out. Please Try again',
//                 message_type: 2,
//                 message_box_open: true,
//             })
//         }
//         http.onerror = function () {
//             global_ref.setState({
//                 loading: false,
//                 message_title: 'Error',
//                 message_body: 'Server encountered an error. Please try again',
//                 message_type: 2,
//                 message_box_open: true,
//             })
//         }
//     }

//     delete_organization = () => {
//         var id = '' + this.state.deleteTarget.organisation_id
//         // document.getElementById(id).outerHTML = "";
//         this.setState({
//             loading: true,
//             deleteModalOpen: false,
//         })
//         var cookies = new Cookies()
//         var http = new XMLHttpRequest()
//         var global_ref = this
//         var user_id = cookies.get('user_id')
//         var token = cookies.get('token')
//         http.open(
//             'DELETE',
//             url + '/api/organisation?user_id=' + user_id + '&org_id=' + id,
//             true
//         )
//         http.setRequestHeader('Authorization', 'Token ' + token)
//         http.send()
//         http.onreadystatechange = function () {
//             if (http.readyState === 4 && http.status === 200) {
//                 var json = JSON.parse(http.responseText)
//                 if (json.status === 204) {
//                     document.getElementById(id).outerHTML = ''
//                     global_ref.setState({
//                         loading: false,
//                     })
//                 } else {
//                     global_ref.setState({
//                         loading: false,
//                         message_title: 'Error',
//                         message_body: 'Organization could not be deleted',
//                         message_type: 2,
//                         message_box_open: true,
//                     })
//                 }
//             }
//         }
//         http.ontimeout = function () {
//             global_ref.setState({
//                 loading: false,
//                 message_title: 'Timeout',
//                 message_body: 'Request has timed out. Please Try again',
//                 message_type: 2,
//                 message_box_open: true,
//             })
//         }
//         http.onerror = function () {
//             global_ref.setState({
//                 loading: false,
//                 message_title: 'Error',
//                 message_body: 'Server encountered an error. Please try again',
//                 message_type: 2,
//                 message_box_open: true,
//             })
//         }
//     }

//     hasExtension = (inputID, exts) => {
//         var fileName = document.getElementById(inputID).value
//         return new RegExp(
//             '(' + exts.join('|').replace(/\./g, '\\.') + ')$'
//         ).test(fileName)
//     }

//     search_target_organization = (id) => {
//         //(id)
//         this.state.org_list.forEach((element) => {
//             if ('' + element.organisation_id === id) {
//                 //("*****")
//                 //(element)

//                 this.setState({
//                     editTarget: element,
//                     editModalOpen: true,
//                     org_name: element.organisation_name,
//                     org_days: element.days_to_delete_photos,
//                 })
//             }
//         })
//     }

//     triggerOrgDeletion = (id) => {
//         this.state.org_list.forEach((element) => {
//             if ('' + element.organisation_id === id) {
//                 this.setState({
//                     deleteTarget: element,
//                     deleteModalOpen: true,
//                     message_title: 'Delete Organization',
//                     message_body:
//                         'Are you sure you want to delete ' +
//                         element.organisation_name +
//                         '?',
//                 })
//             }
//         })
//     }

//     OpenFileBrowser = () => {
//         var elem = document.getElementById('logo')
//         if (elem && document.createEvent) {
//             var evt = document.createEvent('MouseEvents')
//             evt.initEvent('click', true, false)
//             elem.dispatchEvent(evt)
//         }
//     }

//     changePreviewImg = () => {
//         //('selected')
//         var input = document.getElementById('logo')
//         if (
//             !this.hasExtension('logo', [
//                 '.jpg',
//                 '.png',
//                 '.bmp',
//                 '.JPG',
//                 'jpeg',
//                 'JPEG',
//                 '.PNG',
//                 '.BMP',
//             ])
//         ) {
//             this.setState({
//                 FileErrorHidden: false,
//                 message_body:
//                     'This file format is not supported. Only PNG, JPG and BMP files are allowed',
//             })
//             setTimeout(
//                 function () {
//                     this.setState({
//                         FileErrorHidden: true,
//                     })
//                 }.bind(this),
//                 2000
//             )
//             return
//         }
//         if (input.files && input.files[0]) {
//             var reader = new FileReader()

//             reader.onload = function (e) {
//                 //(e.target.result)
//                 document
//                     .getElementById('logoThumbnail')
//                     .setAttribute('src', e.target.result)
//             }
//             this.setState({
//                 editImageChanged: true,
//             })
//             reader.readAsDataURL(input.files[0])
//         }
//     }

//     clear = () => {
//         this.state.org_list = []
//     }

//     render() {
//         if (section === 0) {
//             return (
//                 <div>
//                     <Loader loading={true} fullPage={true} />
//                 </div>
//             )
//         }

//         if (section === 1) {
//             if (this.state.super_admin === 'true') {
//                 return (
//                     <div>
//                         <Loader loading={this.state.loading} fullPage={true} />
//                         <Modal isOpen={messageBoxOpen}>
//                             <ModalHeader>
//                                 {messageTitle}
//                             </ModalHeader>
//                             <ModalBody>{messageBody}</ModalBody>
//                             <ModalFooter>
//                                 <Button
//                                     color="primary"
//                                     onClick={closeMessageBoxModal}
//                                 >
//                                     Close
//                                 </Button>
//                             </ModalFooter>
//                         </Modal>
//                         {/* question edit modal */}
//                         <Modal isOpen={editModalOpen}>
//                             <ModalHeader>Edit Organization</ModalHeader>
//                             <ModalBody>
//                                 <form id="orgData">
//                                     <div class="form-group">
//                                         <label for="exampleInputEmail1">
//                                             <h3>Organization Name</h3>
//                                         </label>
//                                         <input
//                                             type="text"
//                                             class="form-control"
//                                             id="org_name"
//                                             value={orgName}
//                                             placeholder="Enter organization name"
//                                             onChange={
//                                                 handleNameInputChange
//                                             }
//                                         ></input>
//                                     </div>
//                                     <div class="form-group">
//                                         <label>
//                                             <h3>Days To Delete Photos After</h3>
//                                         </label>
//                                         <input
//                                             type="number"
//                                             class="form-control"
//                                             id="org_days"
//                                             value={this.state.org_days}
//                                             placeholder="Specify number of days after which photos will be delete from the device"
//                                             onChange={
//                                                 this.handleDaysInputChange
//                                             }
//                                         ></input>
//                                     </div>
//                                     <label for="exampleInputFile">
//                                         <h3>Logo</h3>
//                                     </label>
//                                     <div class="form-group ">
//                                         {/* <input type="file" id="logofile"></input> */}
//                                         <div class="thumbnail">
//                                             <img
//                                                 id="logoThumbnail"
//                                                 src={
//                                                     media_url +
//                                                     editTarget
//                                                         .organisation_logo
//                                                 }
//                                                 alt=""
//                                             ></img>
//                                             <h3 onClick={openFileBrowser}>
//                                                 Update
//                                             </h3>
//                                             <input
//                                                 type="file"
//                                                 id="logo"
//                                                 hidden={true}
//                                                 onChange={changePreviewImg}
//                                             />
//                                         </div>
//                                         <p
//                                             class="isa_error"
//                                             hidden={fileErrorHidden}
//                                         >
//                                             <i class="fa fa-times-circle"></i>
//                                             {messageBody}
//                                         </p>
//                                     </div>
//                                 </form>
//                             </ModalBody>
//                             <ModalFooter>
//                                 <Button onClick={closeEditModal}>
//                                     Cancel
//                                 </Button>
//                                 <Button
//                                     color="primary"
//                                     onClick={updateOrganization}
//                                 >
//                                     Update
//                                 </Button>
//                             </ModalFooter>
//                         </Modal>
//                         <Modal isOpen={deleteModalOpen}>
//                             <ModalHeader>
//                                 {messageTitle}
//                             </ModalHeader>
//                             <ModalBody>{messageBody}</ModalBody>
//                             <ModalFooter>
//                                 <Button onClick={closeDeleteModal}>
//                                     Cancel
//                                 </Button>
//                                 <Button
//                                     color="primary"
//                                     onClick={deleteOrganization}
//                                 >
//                                     Delete
//                                 </Button>
//                             </ModalFooter>
//                         </Modal>
//                         <div className="clearfix" id="page-header">
//                             <div>
//                                 <Header />
//                             </div>
//                         </div>

//                         <div>
//                             <SideBar />
//                         </div>

//                         <div
//                             id="page-content-wrapper"
//                             className="rm-transition"
//                         >
//                             <div id="page-content">
//                                 <div class="example-box-wrapper">
//                                     <div className="row">
//                                         <div className="col-md-4"></div>
//                                         <div className="col-md-4">
//                                             <h2 style={{ textAlign: 'center' }}>
//                                                 {' '}
//                                                 Organizations
//                                             </h2>
//                                             {/* <button onClick={this.clear.bind(this)}>Clear</button> */}
//                                         </div>
//                                         <div className="col-md-4">
//                                             <a
//                                                 class="create-org-btn"
//                                                 onClick={
//                                                     navigateCreateOrganization
//                                                 }
//                                             >
//                                                 <span
//                                                     class="fa fa-plus"
//                                                     style={{ color: 'white' }}
//                                                 ></span>
//                                                 <b
//                                                     onClick={
//                                                         navigateCreateOrganization
//                                                     }
//                                                 >
//                                                     Create Organization
//                                                 </b>
//                                             </a>
//                                             <a
//                                                 href={
//                                                     '/list-revoked-organizations/'
//                                                 }
//                                                 class="notification"
//                                                 hidden={
//                                                     this.state
//                                                         .inactive_count === 0
//                                                 }
//                                             >
//                                                 <span>
//                                                     Inactive Organizations
//                                                 </span>
//                                                 <span class="badge">
//                                                     {inactiveCount}
//                                                 </span>
//                                             </a>
//                                         </div>
//                                     </div>

//                                     <BottomScrollListener
//                                         onBottom={loadMore}
//                                     >
//                                         <div
//                                             className="row"
//                                             style={{ marginTop: 30 }}
//                                         >
//                                             {/* <Fade top> */}
//                                             {this.state.org_list.map(
//                                                 (org, i) => (
//                                                     <OrganizationViewPanel
//                                                         key={i}
//                                                         data={org}
//                                                         triggerEdit={
//                                                             this
//                                                                 .search_target_organization
//                                                         }
//                                                         triggerDelete={
//                                                             this
//                                                                 .triggerOrgDeletion
//                                                         }
//                                                         userType="super"
//                                                     />
//                                                 )
//                                             )}
//                                             {/* </Fade> */}
//                                         </div>

//                                         <div className="row">
//                                             <div className="col-md-4"></div>
//                                             <div className="col-md-4">
//                                                 <img
//                                                     src={loadingGif}
//                                                     alt="no image"
//                                                     height={25}
//                                                     width={25}
//                                                     style={{ marginLeft: 70 }}
//                                                     hidden={
//                                                         this.state
//                                                             .contentLoaderHidden
//                                                     }
//                                                 ></img>
//                                             </div>
//                                             <div className="col-md-4"></div>
//                                         </div>
//                                     </BottomScrollListener>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 )
//             }
//             if (this.state.org_admin === 'true') {
//                 return (
//                     <div>
//                         <Loader loading={this.state.loading} fullPage={true} />
//                         <Modal isOpen={messageBoxOpen}>
//                             <ModalHeader>
//                                 {messageTitle}
//                             </ModalHeader>
//                             <ModalBody>{messageBody}</ModalBody>
//                             <ModalFooter>
//                                 <Button
//                                     color="primary"
//                                     onClick={closeMessageBoxModal}
//                                 >
//                                     Close
//                                 </Button>
//                             </ModalFooter>
//                         </Modal>
//                         {/* question edit modal */}
//                         <Modal isOpen={editModalOpen}>
//                             <ModalHeader>Edit Organization</ModalHeader>
//                             <ModalBody>
//                                 <form id="orgData">
//                                     <div class="form-group">
//                                         <label for="exampleInputEmail1">
//                                             <h3>Organization Name</h3>
//                                         </label>
//                                         <input
//                                             type="text"
//                                             class="form-control"
//                                             id="org_name"
//                                             value={orgName}
//                                             placeholder="Enter organization name"
//                                             onChange={
//                                                 handleNameInputChange
//                                             }
//                                         ></input>
//                                     </div>
//                                     <label for="exampleInputFile">
//                                         <h3>Logo</h3>
//                                     </label>
//                                     <div class="form-group ">
//                                         {/* <input type="file" id="logofile"></input> */}
//                                         <div class="thumbnail">
//                                             <img
//                                                 id="logoThumbnail"
//                                                 src={
//                                                     media_url +
//                                                     editTarget
//                                                         .org_logo
//                                                 }
//                                                 alt=""
//                                             ></img>
//                                             <h3 onClick={openFileBrowser}>
//                                                 Update
//                                             </h3>
//                                             <input
//                                                 type="file"
//                                                 id="logo"
//                                                 hidden={true}
//                                                 onChange={changePreviewImg}
//                                             />
//                                         </div>
//                                         <p
//                                             class="isa_error"
//                                             hidden={fileErrorHidden}
//                                         >
//                                             <i class="fa fa-times-circle"></i>
//                                             {messageBody}
//                                         </p>
//                                     </div>
//                                 </form>
//                             </ModalBody>
//                             <ModalFooter>
//                                 <Button onClick={closeEditModal}>
//                                     Cancel
//                                 </Button>
//                                 <Button
//                                     color="primary"
//                                     onClick={updateOrganization}
//                                 >
//                                     Update
//                                 </Button>
//                             </ModalFooter>
//                         </Modal>
//                         <Modal isOpen={deleteModalOpen}>
//                             <ModalHeader>
//                                 {messageTitle}
//                             </ModalHeader>
//                             <ModalBody>{messageBody}</ModalBody>
//                             <ModalFooter>
//                                 <Button onClick={closeDeleteModal}>
//                                     Cancel
//                                 </Button>
//                                 <Button
//                                     color="primary"
//                                     onClick={deleteOrganization}
//                                 >
//                                     Delete
//                                 </Button>
//                             </ModalFooter>
//                         </Modal>
//                         <div className="clearfix" id="page-header">
//                             <div>
//                                 <Header />
//                             </div>
//                         </div>

//                         <div>
//                             <SideBar />
//                         </div>
//                         <div
//                             id="page-content-wrapper"
//                             className="rm-transition"
//                         >
//                             <div id="page-content">
//                                 <div class="example-box-wrapper">
//                                     <div className="row">
//                                         <div className="col-md-4"></div>
//                                         <div className="col-md-4">
//                                             <h2 style={{ textAlign: 'center' }}>
//                                                 Organizations
//                                             </h2>
//                                         </div>
//                                         <div className="col-md-4"></div>
//                                     </div>
//                                     <BottomScrollListener
//                                         onBottom={loadMore}
//                                     >
//                                         <div
//                                             className="row"
//                                             style={{ marginTop: 30 }}
//                                         >
//                                             {this.state.org_list.map(
//                                                 (org, i) => (
//                                                     <OrganizationViewPanel
//                                                         key={i}
//                                                         data={org}
//                                                         triggerEdit={
//                                                             this
//                                                                 .search_target_organization
//                                                         }
//                                                         triggerDelete={
//                                                             this
//                                                                 .triggerOrgDeletion
//                                                         }
//                                                         userType="org"
//                                                     />
//                                                 )
//                                             )}
//                                         </div>
//                                         <div className="row">
//                                             <div className="col-md-4"></div>
//                                             <div className="col-md-4">
//                                                 <img
//                                                     src={loadingGif}
//                                                     alt="no image"
//                                                     height={25}
//                                                     width={25}
//                                                     style={{ marginLeft: 70 }}
//                                                     hidden={
//                                                         this.state
//                                                             .contentLoaderHidden
//                                                     }
//                                                 ></img>
//                                             </div>
//                                             <div className="col-md-4"></div>
//                                         </div>
//                                     </BottomScrollListener>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 )
//             }
//         }
//         if (section === 2) {
//             return (
//                 <div>
//                     <div className="clearfix" id="page-header">
//                         <div>
//                             <Header />
//                         </div>
//                     </div>

//                     <div>
//                         <SideBar />
//                     </div>
//                     <div id="page-content-wrapper" className="rm-transition">
//                         <div id="page-content">
//                             <div class="example-box-wrapper">
//                                 <div className="row">
//                                     <div className="col-md-4"></div>
//                                     <div className="col-md-4">
//                                         <h3 style={{ textAlign: 'center' }}>
//                                             No Organizations
//                                         </h3>
//                                     </div>
//                                     <div className="col-md-4">
//                                         <a
//                                             class="create-org-btn"
//                                             onClick={navigateCreateOrganization}
//                                         >
//                                             <span
//                                                 class="fa fa-plus"
//                                                 style={{ color: 'white' }}
//                                             ></span>
//                                             <b
//                                                 onClick={
//                                                     navigateCreateOrganization
//                                                 }
//                                             >
//                                                 Create Organization
//                                             </b>
//                                         </a>
//                                         <a
//                                             href={
//                                                 '/list-revoked-organizations/'
//                                             }
//                                             class="notification"
//                                             hidden={
//                                                 inactiveCount === 0
//                                             }
//                                         >
//                                             <span>Inactive Organizations</span>
//                                             <span class="badge">
//                                                 {inactiveCount}
//                                             </span>
//                                         </a>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             )
//         }
//     }
// }

// export default OrganizationList

import React from 'react'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import Cookies from 'universal-cookie'
import '../CSS/assets-minified/all-demo.css'
import '../CSS/assets-minified/css/bootstrap.min.css'
import Header from '../components/dashboardSubComponents/header'
import SideBar from '../components/dashboardSubComponents/sideBarNav'
// import Fade from 'react-reveal/Fade'
import { Loader } from 'react-overlay-loader'
import OrganizationViewPanel from '../components/OrganizationViewSubComponents/organizationViewPanel'
import { logout, media_url, url } from '../components/helper'
// import update from 'react-addons-update';
import BottomScrollListener from 'react-bottom-scroll-listener'
import loadingGif from '../CSS/assets-minified/images/loadingMore.gif'
// import CreateOrganization from './CreateOrganization'

const OrganizationView = () => {
    const [superAdmin, setSuperAdmin] = React.useState('')
    const [orgAdmin, setOrgAdmin] = React.useState('')
    const [orgList, setOrgList] = React.useState([])
    const [orgName, setOrgName] = React.useState('')
    const [section, setSection] = React.useState(0)
    const [editModalOpen, setEditModalOpen] = React.useState(false)
    const [editTarget, setEditTarget] = React.useState({
        org_name: 'fake',
        org_logo: 'logo',
    })
    const [editImageChanged, setEditImageChanged] = React.useState(false)
    const [deleteModalOpen, setDeleteModalOpen] = React.useState(false)
    const [deleteTarget, setDeleteTarget] = React.useState({ org_id: 'id' })
    const [editCurrentImg, setEditCurrentImg] = React.useState(
        'https://res.cloudinary.com/argon-tech/image/upload/v1532955025/kncikwliledqmw1nlqih.jpg'
    )
    const [loading, setLoading] = React.useState(false)
    const [messageTitle, setMessageTitle] = React.useState('')
    const [messageBody, setMessageBody] = React.useState('')
    const [messageType, setMessageType] = React.useState(1)
    const [messageBoxOpen, setMessageBoxOpen] = React.useState(false)
    const [fileErrorHidden, setFileErrorHidden] = React.useState(true)
    const [inactiveCount, setInactiveCount] = React.useState(0)
    const [orgDays, setOrgDays] = React.useState(1)
    const [contentLoaderHidden, setContentLoaderHidden] = React.useState(true)
    const [currentPage, setCurrentPage] = React.useState(1)
    const [hasNext, setHasNext] = React.useState(false)

    //Change preview image
    const changePreviewImg = () => {
        const input = document.getElementById('logo')
        if (
            !hasExtension('logo', [
                '.jpg',
                '.png',
                '.bmp',
                '.JPG',
                '.PNG',
                '.BMP',
            ])
        ) {
            setFileErrorHidden(false)
            setMessageBody(
                'This file format is not supported. Only PNG, JPG and BMP files are allowed'
            )
            setTimeout(() => {
                setFileErrorHidden(true)
            }, 2000)
        }
        if (input.files && input.files[0]) {
            const reader = new FileReader()

            reader.onload = (e) => {
                document
                    .getElementById('logoThumbnail')
                    .setAttribute('src', e.target.result)
            }
            setEditImageChanged(true)
            reader.readAsDataURL(input.files[0])
        }
    }
    //Clear organization list
    const clear = () => {
        setOrgList([])
    }

    //All file selection
    const openFileBrowser = () => {
        const elem = document.getElementById('logo')
        if (elem) {
            const evt = document.createEvent('MouseEvents')
            evt.initEvent('click', true, false)
            elem.dispatchEvent(evt)
        }
    }

    //Checks if the file has a valid extension
    const hasExtension = (inputID, exts) => {
        const fileName = document.getElementById(inputID).value
        const re_file = new RegExp(
            '(' + exts.join('|').replace(/\./g, '\\.') + ')$'
        )
        return re_file.test(fileName)
    }

    const closeMessageBoxModal = () => {
        setMessageBoxOpen(messageType !== 1 && messageType !== 2)
        if (messageType === 1) {
            window.location = '/view-organization'
        }
    }
    //Handles closing the edit modal
    const closeEditModal = () => {
        setEditModalOpen(false)
    }
    //Handles closing the delete modal
    const closeDeleteModal = () => {
        setDeleteModalOpen(false)
    }
    //Handles changing the organization name change
    const handleNameInputChange = () => {
        const input = document.getElementById('org_name').value
        setOrgName(input)
    }
    //Handles changing the organization days change
    const handleDaysInputChange = () => {
        const input = document.getElementById('org_days').value
        setOrgDays(input)
    }

    //Navigates to create organization page
    const navigateCreateOrganization = () => {
        window.location = '/create-organization'
    }

    //Verify credentials and set states
    const credentialCheck = () => {
        const cookies = new Cookies()
        const branchAdmin = cookies.get('branch-admin')
        const superuser = cookies.get('superuser')
        const organizationAdmin = cookies.get('organization-admin')

        const token = cookies.get('token')
        if (!token) {
            window.location = '/login'
        }

        if (branchAdmin === 'true') {
            window.location = '/dashboard'
        }

        setSuperAdmin(superuser)
        setOrgAdmin(organizationAdmin)
    }

    //Get all the organizations to display
    const getAllOrganization = async () => {
        const cookies = new Cookies()
        const userId = cookies.get('user_id')
        const token = cookies.get('token')

        const options = {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }

        try {
            const res = await fetch(
                `${url}/api/organisation?user_id=${userId}&page=${currentPage}`,
                options
            )
            const data = await res.json()

            if (res.status === 401) {
                logout()
            }
            switch (data.status) {
                case 200:
                    setOrgList(data.organisations)
                    setInactiveCount(data.inactive_orgs_count)
                    setHasNext(data.has_next)
                    setSection(1)

                    break
                default:
                    setInactiveCount(data.inactive_orgs_count)
                    setSection(2)
                    break
            }
        } catch (err) {
            console.error('Error', err)
        }
    }

    //Runs functions once on initial page render
    React.useEffect(() => {
        credentialCheck()
        getAllOrganization()
    }, [])

    //Display modal confirmation on deletion via card
    const triggerOrgDeletion = (id) => {
        orgList.forEach((org) => {
            if (org.organisation_id === parseInt(id)) {
                setDeleteTarget(org)
                setDeleteModalOpen(true)
                setMessageTitle('Delete Organization')
                setMessageBody(
                    `Are you sure you want to delete ${org.organisation_name} ?`
                )
            }
        })
    }

    //Edit organisation and forces a rerender
    //Could trigger a rerender by spread operator no?
    const updateOrganization = async (event) => {
        event.preventDefault()
        setLoading(true)
        setEditModalOpen(false)
        const cookies = new Cookies()
        const user_id = cookies.get('user_id')
        const token = cookies.get('token')
        let fileInput = null
        let file = null

        if (editImageChanged) {
            fileInput = document.getElementById('logo')
            file = fileInput.files[0]
        }

        const nameInput = document.getElementById('org_name').value
        const formData = new FormData()
        formData.append('org_logo', file)
        formData.append('org_name', nameInput)
        formData.append('days', orgDays)
        formData.append('user_id', user_id)
        formData.append('org_id', editTarget.organisation_id)

        const options = {
            method: 'PUT',
            headers: {
                Authorization: `Bearer ${token}`,
            },
            body: formData,
        }

        try {
            const res = await fetch(`${url}/api/organisation`, options)
            const data = await res.json()

            switch (data.status) {
                case 200:
                    const id = editTarget.organisation_id
                    document.getElementById(`name${id}`).innerText =
                        data.organisation_name
                    orgList.forEach((org) => {
                        if (
                            org.organisation_id === editTarget.organisation_id
                        ) {
                            org = {
                                organisation_name: data.organisation_name,
                                organisation_logo: data.organisation_logo,
                                days_to_delete_photos:
                                    data.days_to_delete_photos,
                            }
                            // this.forceUpdate() //What is this?
                        }
                    })
                    setLoading(false)
                    setMessageTitle('Success')
                    setMessageBody('Organization has been updated successfully')
                    setMessageType(2)
                    setMessageBoxOpen(true)
                    break
                default:
                    setLoading(false)
                    setMessageTitle('Error')
                    setMessageBody('Organization could not be updated')
                    setMessageType(2)
                    setMessageBoxOpen(true)
                    break
            }
        } catch (err) {
            console.error('Error', err)
            setLoading(false)
            setMessageTitle('Error')
            setMessageBody('Server encountered an error. Please try again')
            setMessageType(2)
            setMessageBoxOpen(true)
        }
    }

    //Delete Organization based on id
    const deleteOrganization = async () => {
        const id = deleteTarget.organisation_id
        setLoading(true)
        setDeleteModalOpen(false)

        const cookies = new Cookies()
        const user_id = cookies.get('user_id')
        const token = cookies.get('token')

        const options = {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }

        try {
            const res = await fetch(
                `${url}/api/organisation?user_id=${user_id}&org_id=${id}`,
                options
            )
            const data = await res.json()
            switch (data.status) {
                case 204:
                    document.getElementById(id).outerHTML = '' //Must be a better way
                    setLoading(false)
                    break
                default:
                    setLoading(false)
                    setMessageTitle('Error')
                    setMessageBody('Organization could not be deleted')
                    setMessageType(2)
                    setMessageBoxOpen(true)
                    break
            }
        } catch (err) {
            setLoading(false)
            setMessageTitle('Error')
            setMessageBody('Server encountered an error. Please try again')
            setMessageType(2)
            setMessageBoxOpen(true)
        }
    }

    //Set the target organisation on id selection for the modal
    const searchTargetOrganization = (id) => {
        orgList.forEach((org) => {
            if (org.organisation_id === parseInt(id)) {
                setEditTarget(org)
                setEditModalOpen(true)
                setOrgName(org.organisation_name)
                setOrgDays(org.days_to_delete_photos)
            }
        })
    }

    //Infinite scroll trigger for organization
    const loadMore = async () => {
        if (hasNext) {
            setCurrentPage(currentPage + 1)
            setContentLoaderHidden(false)

            const cookies = new Cookies()
            const user_id = cookies.get('user_id')
            const token = cookies.get('token')

            const options = {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }

            try {
                const res = await fetch(
                    `${url}/api/organisation?user_id=${user_id}&page=${currentPage}`,
                    options
                ) //Note: Current page is not incremented from state, might cause bugs in future
                const data = await res.json()

                if (res.status === 401) {
                    logout()
                }

                switch (data.status) {
                    case 200:
                        setInactiveCount(data.inactive_orgs_count)
                        setContentLoaderHidden(true)
                        setHasNext(data.has_next)
                        setOrgList(orgList.concat(data.organisations))
                    default:
                        break
                }
            } catch (err) {
                console.error('Error', err)
            }
        }
    }

    if (section === 0) {
        return (
            <div>
                <Loader loading={true} fullPage={true} />
            </div>
        )
    }

    if (section === 1) {
        return (
            <div>
                <Loader loading={loading} fullPage={true} />
                <Modal isOpen={messageBoxOpen}>
                    <ModalHeader>{messageTitle}</ModalHeader>
                    <ModalBody>{messageBody}</ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={closeMessageBoxModal}>
                            Close
                        </Button>
                    </ModalFooter>
                </Modal>
                {/* question edit modal */}
                <Modal isOpen={editModalOpen}>
                    <ModalHeader>Edit Organization</ModalHeader>
                    <ModalBody>
                        <form id="orgData">
                            <div class="form-group">
                                <label for="exampleInputEmail1">
                                    <h3>Organization Name</h3>
                                </label>
                                <input
                                    type="text"
                                    class="form-control"
                                    id="org_name"
                                    value={orgName}
                                    placeholder="Enter organization name"
                                    onChange={handleNameInputChange}
                                ></input>
                            </div>
                            {/* Only allow Days to delete for super admins */}
                            {superAdmin === 'true' ? (
                                <div class="form-group">
                                    <label>
                                        <h3>Days To Delete Photos After</h3>
                                    </label>
                                    <input
                                        type="number"
                                        class="form-control"
                                        id="org_days"
                                        value={orgDays}
                                        placeholder="Specify number of days after which photos will be delete from the device"
                                        onChange={handleDaysInputChange}
                                    ></input>
                                </div>
                            ) : (
                                <div></div>
                            )}

                            <label for="exampleInputFile">
                                <h3>Logo</h3>
                            </label>
                            <div class="form-group ">
                                <div class="thumbnail">
                                    <img
                                        id="logoThumbnail"
                                        src={
                                            media_url +
                                            editTarget.organisation_logo
                                        }
                                        alt=""
                                    ></img>
                                    <h3 onClick={openFileBrowser}>Update</h3>
                                    <input
                                        type="file"
                                        id="logo"
                                        hidden={true}
                                        onChange={changePreviewImg}
                                    />
                                </div>
                                <p class="isa_error" hidden={fileErrorHidden}>
                                    <i class="fa fa-times-circle"></i>
                                    {messageBody}
                                </p>
                            </div>
                        </form>
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={closeEditModal}>Cancel</Button>
                        <Button color="primary" onClick={updateOrganization}>
                            Update
                        </Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={deleteModalOpen}>
                    <ModalHeader>{messageTitle}</ModalHeader>
                    <ModalBody>{messageBody}</ModalBody>
                    <ModalFooter>
                        <Button onClick={closeDeleteModal}>Cancel</Button>
                        <Button color="primary" onClick={deleteOrganization}>
                            Delete
                        </Button>
                    </ModalFooter>
                </Modal>
                <div className="clearfix" id="page-header">
                    <div>
                        <Header />
                    </div>
                </div>

                <div>
                    <SideBar />
                </div>

                <div id="page-content-wrapper" className="rm-transition">
                    <div id="page-content">
                        <div class="example-box-wrapper">
                            <div className="row">
                                <div className="col-md-4"></div>
                                <div className="col-md-4">
                                    <h2 style={{ textAlign: 'center' }}>
                                        Organizations
                                    </h2>
                                </div>
                                {superAdmin === 'true' ? (
                                    <div className="col-md-4">
                                        <a
                                            class="create-org-btn"
                                            onClick={navigateCreateOrganization}
                                        >
                                            <span
                                                class="fa fa-plus"
                                                style={{ color: 'white' }}
                                            ></span>
                                            <b
                                                onClick={
                                                    navigateCreateOrganization
                                                }
                                            >
                                                Create Organization
                                            </b>
                                        </a>
                                        <a
                                            href={
                                                '/list-revoked-organizations/'
                                            }
                                            class="notification"
                                            hidden={inactiveCount === 0}
                                        >
                                            <span>Inactive Organizations</span>
                                            <span class="badge">
                                                {inactiveCount}
                                            </span>
                                        </a>
                                    </div>
                                ) : (
                                    <div></div>
                                )}
                            </div>

                            <BottomScrollListener onBottom={loadMore}>
                                <div className="row" style={{ marginTop: 30 }}>
                                    {orgList.map((org, i) => (
                                        <OrganizationViewPanel
                                            key={i}
                                            data={org}
                                            triggerEdit={
                                                searchTargetOrganization
                                            }
                                            triggerDelete={triggerOrgDeletion}
                                            // here is super or
                                            userType={
                                                superAdmin === 'true'
                                                    ? 'super'
                                                    : 'org'
                                            }
                                        />
                                    ))}
                                    {/* </Fade> */}
                                </div>

                                <div className="row">
                                    <div className="col-md-4"></div>
                                    <div className="col-md-4">
                                        <img
                                            src={loadingGif}
                                            alt="no image"
                                            height={25}
                                            width={25}
                                            style={{ marginLeft: 70 }}
                                            hidden={contentLoaderHidden}
                                        ></img>
                                    </div>
                                    <div className="col-md-4"></div>
                                </div>
                            </BottomScrollListener>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    if (section === 2) {
        return (
            <div>
                <div className="clearfix" id="page-header">
                    <div>
                        <Header />
                    </div>
                </div>

                <div>
                    <SideBar />
                </div>
                <div id="page-content-wrapper" className="rm-transition">
                    <div id="page-content">
                        <div class="example-box-wrapper">
                            <div className="row">
                                <div className="col-md-4"></div>
                                <div className="col-md-4">
                                    <h3 style={{ textAlign: 'center' }}>
                                        No Organizations
                                    </h3>
                                </div>
                                <div className="col-md-4">
                                    <a
                                        class="create-org-btn"
                                        onClick={navigateCreateOrganization}
                                    >
                                        <span
                                            class="fa fa-plus"
                                            style={{ color: 'white' }}
                                        ></span>
                                        <b onClick={navigateCreateOrganization}>
                                            Create Organization
                                        </b>
                                    </a>
                                    <a
                                        href={'/list-revoked-organizations/'}
                                        class="notification"
                                        hidden={inactiveCount === 0}
                                    >
                                        <span>Inactive Organizations</span>
                                        <span class="badge">
                                            {inactiveCount}
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default OrganizationView

/**
 * Notes:
 * - Bunch of redundant handle functions, could be shifted as anon funcs in event
 * - Can shift hasExtension to helper funcs
 * - A lot of redundant onClick events
 * - Sections can and should be combined with conditional rendering
 * - Days to delete photo only available via edit by superadmin? Why can't org admin?
 */



// WEBPACK FOOTER //
// src/Routes/OrganizationView.js